import { InjectionToken } from '@angular/core';
import type { MapLoaderPort } from '../../features/maps/domain/ports/map-loader.port';

// Token para inyectar la implementación del cargador de mapas (wiring hexagonal).
export const MAP_LOADER = new InjectionToken<MapLoaderPort>('MAP_LOADER');
